import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-left-joing-date-popup',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './left-joing-date-popup.component.html',
  styleUrl: './left-joing-date-popup.component.scss'
})
export class LeftJoingDatePopupComponent {
  @Input() JoiningDate: string = '';
  @Input() LeftDate: string = '';
  constructor(
    private activeModal: NgbActiveModal,
  ) { }

  close(result: boolean) {
    this.activeModal.close(result);
  }
}
